var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('collapsable-card',{attrs:{"title":_vm.$t('app.general.title.limits'),"icon":"$limits","draggable":true,"layout-path":"dashboard.printer-limits-card"}},[_c('printer-limits')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }